export interface IconData {
  name: string;
  size?: string;
  color?: string;
  method?: string;
}

export interface ImageData {
  src?: string;
  height?: string;
  width?: string;
}

export interface PrefixSuffixData {
  icon?: IconData;
  prefixText?: string;
  suffixText?: string;
  image?: ImageData;
}

export interface OptionGroupData {
  prefix?: PrefixSuffixData;
  suffix?: PrefixSuffixData;
  textContent?: string;
}